import './surveys_dashboard_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.ClonedSurveyDashboardView extends Monitoring.Views.SocialContents.SurveysDashboardView

  initialize: (@options = {}) ->
    super(@options)
    @searchIsPending = true
    @defaultCharts = @options.defaultCharts
    @searchQuery = @options.searchQuery
    @searchQuery.set('uuid', @uuid)
    @searchQuery.set('name', '')
    @searchQuery.set('offset', 0)
